var render = function render(){var _vm=this,_c=_vm._self._c;return _c('infinite-loading',{attrs:{"identifier":_vm.infiniteId},on:{"infinite":_vm.infiniteHandler}},[_c('div',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('loading-spinner')],1),_c('div',{attrs:{"slot":"no-more"},slot:"no-more"}),_c('div',{attrs:{"slot":"no-results"},slot:"no-results"},[_vm._v(" No results ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }